import React from 'react';

const OMB_NUMBER = '2900-0657';
const OMB_EXP_DATE = '03/31/2027';

const OmbInfo = () => {
  return (
    <div className="vads-u-margin-bottom--1p5">
      <p className="vads-u-margin--0">
        <span>Respondent burden:</span>{' '}
        <span className="vads-u-font-weight--bold">10 minutes</span>
      </p>
      <p className="vads-u-margin--0">
        <span>OMB Control #:</span>{' '}
        <span className="vads-u-font-weight--bold"> {OMB_NUMBER}</span>
      </p>
      <p className="vads-u-margin--0">
        <span>Expiration date:</span>{' '}
        <span className="vads-u-font-weight--bold"> {OMB_EXP_DATE}</span>
      </p>
    </div>
  );
};

export default OmbInfo;
